import React from 'react';

import Checkbox from '@mui/material/Checkbox';

import ExpandableCard from 'components/ExpandableCard';
import VisibilitySection from 'components/Transactions/VisibilitySection';

import { useField } from 'app-components/flux/transaction-rules/transactionRulesFormHooks';

import useStyles from '../styles';

function ExcludedTarget() {
  const { value: reportValue, onValueChange: onExcludedFromReportValueChanged } = useField('excludeFromReportsTarget');
  const { value: f2sValue, onValueChange: onExcludedFromF2SValueChanged } = useField('excludeFromF2STarget');

  return (
    <VisibilitySection
      hideTitle
      excludeF2S={f2sValue}
      setExcludeF2S={onExcludedFromF2SValueChanged}
      excludeReports={reportValue}
      setExcludeReports={onExcludedFromReportValueChanged}
    />
  );
}

export function ExcludedTargetCard(props: any) {
  const { classes, theme } = useStyles();
  const { value, onValueChange } = useField('isEnabledExcludedTarget');

  const toggleEnabled = () => onValueChange(!value);

  return (
    <ExpandableCard
      id='rule-excluded-target'
      className={classes.card}
      title='Exclude from:'
      cardHeaderProps={{ padding: `${theme.spacing(1.5)} ${theme.spacing(2)}` }}
      titleProps={{ variant: 'subtitle2' }}
      expandIcon={<Checkbox id='rule-excluded-target-enabled' checked={value} onClick={toggleEnabled}></Checkbox>}
      isExpanded={value || !!props.hideToggle}
      hideToggle={!!props.hideToggle}
    >
      <ExcludedTarget />
    </ExpandableCard>
  );
}
